import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import MarkdownLink from "../components/MarkdownLink";

interface ReleaseNoteBodyProps {
  body: string;
}

// No raw HTML plugin is added, so ReactMarkdown makes no element from HTML in
// a body; images are dropped and links go through the shared MarkdownLink.
export default function ReleaseNoteBody({ body }: ReleaseNoteBodyProps) {
  return (
    <div className="release-note-body">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{ a: MarkdownLink, img: () => null }}
      >
        {body}
      </ReactMarkdown>
    </div>
  );
}
